'use client';

import AboutPage from '@/app/about/page';

export default function LocalizedAboutPage({ params }: { params: { locale: string } }) {
  return <AboutPage params={params} />;
} 